import styles from "./Rodape.module.css";

export default function Rodape() {
  return (
    <footer className={styles.rodape}>
      &copy; Desenvolvido por Thainá Lopes
    </footer>
  );
}
